import React from "react";
import styled from "styled-components";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// components
import Avatar from "frontend/components/core/Avatar";
import Content from "./Content";

//styles
import { convertPxToRem } from "frontend/components/helpers";
const AuthProfileStyled = styled.div`
    display: flex;
`;
const AvatarStyled = styled.div`
    flex: 0 0 44;
    margin-right: ${convertPxToRem(16)};
`;

// component
const AuthProfile = () => {
    const { currentUser } = useSiteHeader();
    return (
        <AuthProfileStyled>
            <AvatarStyled>
                <Avatar user={currentUser} size={48} />
            </AvatarStyled>
            <Content />
        </AuthProfileStyled>
    );
};

export default AuthProfile;
